/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-play-outline': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm0-1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zM7.5 14.375a.625.625 0 01-.625-.625v-7.5c0-.22.116-.425.306-.537a.625.625 0 01.625 0l6.875 3.75a.625.625 0 010 1.1l-6.875 3.75a.625.625 0 01-.306.062zM8.125 7.3v5.4l4.944-2.7-4.944-2.7z"/>'
  }
})
